import { FormControl as ChakraFormControl } from '@chakra-ui/react';

type FormControlProps = React.ComponentProps<typeof ChakraFormControl>;

const FormControl = ({ children, ...props }: Readonly<FormControlProps>) => {
  return <ChakraFormControl {...props}>{children}</ChakraFormControl>;
};

export default FormControl;
